import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FiSearch, FiDownload } from 'react-icons/fi';
import reportesAvanzadosService from '../services/reportesAvanzadosService';
import Loading from '../components/Loading';
import './LibroMayorPage.css';

const LibroMayorPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cuentaId, setCuentaId] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');

  const cargar = async () => {
    if (!cuentaId) { toast.warn('Seleccione una cuenta contable'); return; }
    try {
      setLoading(true);
      const filters = { plan_cuenta_id: cuentaId };
      if (fechaDesde) filters.fecha_desde = fechaDesde;
      if (fechaHasta) filters.fecha_hasta = fechaHasta;
      const res = await reportesAvanzadosService.getLibroMayor(filters);
      setData(res.data);
    } catch { toast.error('Error al cargar libro mayor'); }
    finally { setLoading(false); }
  };

  const formatCurrency = (v) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(v || 0);

  const exportarExcel = async () => {
    try {
      const XLSX = (await import('xlsx')).default;
      const movimientos = data?.movimientos || [];
      const ws = XLSX.utils.json_to_sheet(movimientos.map(m => ({
        Fecha: m.fecha, Glosa: m.glosa, Debe: m.debe, Haber: m.haber, Saldo: m.saldo_acumulado,
      })));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Libro Mayor');
      XLSX.writeFile(wb, `libro_mayor_${cuentaId}.xlsx`);
    } catch { toast.error('Error al exportar'); }
  };

  const movimientos = data?.movimientos || data?.results || [];

  return (
    <div className="libro-mayor-page">
      <div className="page-header"><h1>Libro Mayor</h1></div>

      <div className="selector-bar">
        <div className="form-group">
          <label>Cuenta Contable (ID)</label>
          <input type="number" value={cuentaId} onChange={e => setCuentaId(e.target.value)} placeholder="ID de la cuenta" />
        </div>
        <div className="form-group">
          <label>Desde</label>
          <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Hasta</label>
          <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} />
        </div>
        <button className="btn-primary" onClick={cargar}><FiSearch /> Consultar</button>
        {data && <button className="btn-export" onClick={exportarExcel}><FiDownload /> Excel</button>}
      </div>

      {loading && <Loading />}

      {!loading && data && (
        <>
          <div className="cuenta-info">
            <strong>{data.cuenta_codigo} - {data.cuenta_nombre}</strong>
            <span>Tipo: {data.tipo_cuenta}</span>
          </div>
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr><th>Fecha</th><th>N° Asiento</th><th>Glosa</th><th style={{ textAlign: 'right' }}>Debe</th><th style={{ textAlign: 'right' }}>Haber</th><th style={{ textAlign: 'right' }}>Saldo</th></tr>
              </thead>
              <tbody>
                {movimientos.length === 0 ? (
                  <tr><td colSpan="6" style={{ textAlign: 'center', padding: 40, color: '#6b7280' }}>Sin movimientos</td></tr>
                ) : movimientos.map((m, i) => (
                  <tr key={i}>
                    <td>{m.fecha}</td>
                    <td className="mono">{m.numero_asiento || '-'}</td>
                    <td>{m.glosa}</td>
                    <td className="mono right" style={{ color: m.debe > 0 ? '#dc2626' : undefined }}>{m.debe > 0 ? formatCurrency(m.debe) : ''}</td>
                    <td className="mono right" style={{ color: m.haber > 0 ? '#059669' : undefined }}>{m.haber > 0 ? formatCurrency(m.haber) : ''}</td>
                    <td className="mono right bold">{formatCurrency(m.saldo_acumulado)}</td>
                  </tr>
                ))}
              </tbody>
              {movimientos.length > 0 && (
                <tfoot>
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'right', fontWeight: 700 }}>TOTALES</td>
                    <td className="mono right bold" style={{ color: '#dc2626' }}>{formatCurrency(data.total_debe || movimientos.reduce((s, m) => s + parseFloat(m.debe || 0), 0))}</td>
                    <td className="mono right bold" style={{ color: '#059669' }}>{formatCurrency(data.total_haber || movimientos.reduce((s, m) => s + parseFloat(m.haber || 0), 0))}</td>
                    <td className="mono right bold">{formatCurrency(data.saldo_final || movimientos[movimientos.length - 1]?.saldo_acumulado)}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default LibroMayorPage;
